<template>
  <div>
    <!-- Profit Loss Summary Section Start -->
    <div class="row">
      <div class="col-md-12">
        <h5>
          <b-badge :variant="totPLVal > 0 ? 'success' : totPLVal < 0 ? 'danger' : 'info'"
            >Profit Loss Details</b-badge
          >
        </h5>
        <b-button
          v-if="PL_AccordianButton"
          @click="toggleActive()"
          variant="outline-info"
          size="xs"
          style="font-size: 0.675rem"
          class="mt-1"
          >{{ PL_AccordianStatus ? "Hide Details" : "Show Details" }}</b-button
        >
      </div>
      <div class="col-md-6" v-if="PL_AccordianStatus">
        <h5>
          <b-badge :variant="totPLVal > 0 ? 'success' : totPLVal < 0 ? 'danger' : 'info'"
            >Sales</b-badge
          >
        </h5>
        <table id="otherAdditionalTask" class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Buyer</th>
              <th>Vendor</th>
              <th>Inv No</th>
              <th>Inv Type</th>
              <th>Inv Date</th>
              <th>Inv AMT</th>
              <th>Inv GST AMT</th>
              <th>Total Inv</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getInvoiceList" :key="index">
              <td>{{ item.buyerName }}</td>
              <td>{{ item.vendorName }}</td>
              <td>
                <a
                  style="color: blue"
                  v-if="item.SlineUpload"
                  href="javascript:void(0)"
                  @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${PMS_jb_series.replaceAll('/', '_')}/${item.SlineUpload.replaceAll('/', '_')}`)"
                >
                  <b-button
                    @click="
                      showExpenseDet(
                        item,
                        'Invoice',
                        1,
                        item.DocDtls_No,
                        item.InvjobNo,
                        'Inv'
                      )
                    "
                    variant="outline-info"
                    size="xs"
                    style="font-size: 0.675rem"
                    class="mt-1"
                    >{{ item.DocDtls_No }}</b-button
                  ></a
                >
                <a v-else>
                  <b-button
                    @click="
                      showExpenseDet(
                        item,
                        'Invoice',
                        1,
                        item.DocDtls_No,
                        item.InvjobNo,
                        'Inv'
                      )
                    "
                    variant="outline-info"
                    size="xs"
                    style="font-size: 0.675rem"
                    class="mt-1"
                    >{{ item.DocDtls_No }}</b-button
                  ></a
                ><br/>
                <span>Inv Created : {{ item.inv_create_date }}<br/></span>
                <span>Inv Updated : {{ item.inv_update_date }}</span>
              </td>
              <td>{{ item.DocDtls_Typ }}</td>
              <td>{{ item.Inv_Date }}</td>
              <td>{{ item.AMT }}</td>
              <td>{{ item.GST }}</td>
              <!-- <td>{{ item.IGST }}</td> -->
              <td>{{ item.TotInvVal }}</td>
            </tr>
            <tr v-if="getInvoiceList.length > 0">
              <td colspan="5" class="text-right"><b>Total</b></td>
              <td>
                <b>{{ totInvVal }}</b>
              </td>
              <td>
                <b>{{ totInvGST }}</b>
              </td>
              <td>
                <b>{{ totInvGSTVal }}</b>
              </td>
            </tr>
            <tr v-if="getInvoiceList.length <= 0">
              <td colspan="6" style="text-align: center; color: red">
                <b>NO Invoice Details</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6" v-if="PL_AccordianStatus">
        <h5>
          <b-badge :variant="totPLVal > 0 ? 'success' : totPLVal < 0 ? 'danger' : 'info'"
            >Expense</b-badge
          >
        </h5>
        <table id="otherAdditionalTask" class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Buyer</th>
              <th>Vendor</th>
              <th>Exp No</th>
              <th>Exp Type</th>
              <th>Exp Date</th>
              <th>Exp AMT</th>
              <th>Exp GST AMT</th>
              <th>Total Exp</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getExpenseList" :key="index">
              <td>{{ item.buyerName }}</td>
              <td>{{ item.vendorName }}</td>
              <td>
                <a
                  style="color: blue"
                  v-if="item.SlineUpload"
                  href="javascript:void(0)"
                  @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${PMS_jb_series.replaceAll('/', '_')}/${item.SlineUpload.replaceAll('/', '_')}`)"
                  ><b-button
                    @click="
                      showExpenseDet(
                        item,
                        'Expense',
                        2,
                        item.docDtls_No,
                        item.ExpjobNo,
                        'Exp'
                      )
                    "
                    variant="outline-info"
                    size="xs"
                    style="font-size: 0.675rem"
                    class="mt-1"
                    >{{ item.docDtls_No }}</b-button
                  ></a
                >
                <a v-else>
                  <b-button
                    @click="
                      showExpenseDet(
                        item,
                        'Expense',
                        2,
                        item.docDtls_No,
                        item.ExpjobNo,
                        'Exp'
                      )
                    "
                    variant="outline-info"
                    size="xs"
                    style="font-size: 0.675rem"
                    class="mt-1"
                    >{{ item.docDtls_No }}</b-button
                  ></a
                ><br/>
                <span>Exp Created : {{ item.inv_create_date }}<br/></span>
                <span>Exp Updated : {{ item.inv_update_date }}</span>
              </td>
              <td>{{ item.docDtls_Typ }}</td>
              <td>{{ item.Exp_Date }}</td>
              <td>{{ item.AMT }}</td>
              <td>{{ item.GST }}</td>
              <!-- <td>{{ item.IGST }}</td> -->
              <td>{{ item.TotInvVal }}</td>
            </tr>
            <tr v-if="getExpenseList.length > 0">
              <td colspan="5" class="text-right"><b>Total</b></td>
              <td>
                <b>{{ totExpVal }}</b>
              </td>
              <td>
                <b>{{ totExpGST }}</b>
              </td>
              <td>
                <b>{{ totExpGSTVal }}</b>
              </td>
            </tr>
            <tr v-if="getExpenseList.length <= 0">
              <td colspan="8" style="text-align: center; color: red">
                <b>NO Expense Document ADDED</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12">
        <table id="totalCalculation" class="table table-bordered table-sm">
          <tbody>
            <tr>
              <th scope="row" :style="totPLValColor">Tot Inv : {{ totInvVal }}</th>
              <th scope="row" :style="totPLValColor">Tot Exp : {{ totExpVal }}</th>
              <th scope="row" :style="totPLValColor">
                (Inv-Exp) : ({{ totInvVal }}-{{ totExpVal }})
              </th>
              <th scope="row" :style="totPLValColor">
                Tot
                {{ totPLVal > 0 ? "Profit " : totPLVal < 0 ? "Loss " : "Profit Loss " }} :
                {{ totPLVal }}
              </th>
              <th scope="row" :style="totPLValColor">
                {{ totPLVal > 0 ? "Profit " : totPLVal < 0 ? "Loss " : "Profit Loss " }} %
                : {{ totPLPercentage + " %" }}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      id="otherTallyExpCharges-modal"
      ref="otherTallyExpCharges-modal"
      :title="modal_title + modal_JobNo"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 row">
          <div class="col-md-12">
            <table id="tpt" class="table table-bordered">
              <thead>
                <tr>
                  <th>SN.</th>
                  <th>Particulars</th>
                  <th>Quantity</th>
                  <th>Barcode</th>
                  <th>HSNCode</th>
                  <th>Amount</th>
                  <th>GST Rate</th>
                  <th>IGST Amt</th>
                  <th>CGST Amt</th>
                  <th>SGST Amt</th>
                  <th>Cest Rt/Amt</th>

                  <th>Amt</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in ExpenseItemDeatils" :key="index">
                  <td>{{ index + 1 }}</td>

                  <td>{{ item1.prdDesc }}</td>
                  <td>{{ item1.qty }}</td>
                  <td>{{ item1.barcde }}</td>
                  <td>{{ item1.hsnCd }}</td>
                  <td>
                    {{ item1.totAmt }}
                  </td>
                  <td>{{ item1.gstRt }}</td>
                  <td>
                    {{ item1.igstAmt }}
                  </td>
                  <td>{{ item1.cgstAmt }}</td>
                  <td>{{ item1.sgstAmt }}</td>
                  <td>{{ item1.cesRt }} / {{ item1.cesAmt }}</td>
                  <td>{{ item1.assAmt }}</td>
                  <td>{{ item1.totItemVal }} {{ item1.orgCntry }}</td>
                </tr>
              </tbody>
            </table>
            <br />
            <div>
              <b>Amount + Tax = Total Amount </b>
              <br />
              <b
                >{{ singleItem.AMT }} + {{ taxAmount }} =
                {{ singleItem.TotInvVal }}
              </b>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <center>
              <b-button
                @click="hideExpenseDet"
                style="font-size: 11px"
                size="sm"
                class="mt-1"
                variant="danger"
              >
                Close</b-button
              >
            </center>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Profit Loss Summary Section End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import ProfitLossService from "../../services/ProfitLossService.js";

export default {
  props: [
    "PMS_job_type",
    "PMS_fk_all_module_id",
    "PMS_jb_series",
    "PMS_fk_client_id",
    "PLAccordianStatus",
    "PLAccordianButton",
  ],
  beforeMount() {
    if (this.PMS_fk_all_module_id != "") {
      this.getProfitLossData();
    }
  },
  mounted() {},

  data() {
    return {
      PL_AccordianStatus: this.PLAccordianStatus ? this.PLAccordianStatus : false,
      PL_AccordianButton: this.PLAccordianButton,
      Mtitle: "",
      singleItem: "",
      taxAmount: 0,
      modal_title: "",
      modal_JobNo: "",
      ExpenseItemDeatils: [],
      all_module_id: this.PMS_fk_all_module_id,
      getInvoiceList: [],
      getExpenseList: [],
      docURL: URL_BASE_DOC,

      totInvVal: "",
      totInvGST: "",
      totInvGSTVal: "",

      totExpVal: "",
      totExpGST: "",
      totExpGSTVal: "",

      totPLVal: "",
      totPLGST: "",
      totPLGSTVal: "",

      totPLPercentage: 0,

      totPLValColor: "",
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getProfitLossData();
      },
      deep: true,
    },
  },
  methods: {
    toggleActive() {
      this.PL_AccordianStatus = !this.PL_AccordianStatus;
    },
    showExpenseDet(item, title, type, invNo, jobNo, typeCode) {
      console.log("item=>", item);
      this.Mtitle = "";
      this.Mtitle = title;
      this.singleItem = item;
      this.ExpenseItemDeatils = [];
      this.taxAmount = 0;
      this.ExpenseItemDeatils = item.ExpenseItemDeatils;
      this.taxAmount =
        parseFloat(item.CGST) +
        parseFloat(item.SGST) +
        parseFloat(item.IGST) +
        parseFloat(item.CesVal) +
        parseFloat(item.StCesVal) +
        parseFloat(item.RndOffAmt) +
        parseFloat(item.OthChrg) -
        parseFloat(item.Discount);
      this.modal_title =
        title + " Item List - " + typeCode + " No-" + invNo + " Job No - ";
      this.modal_JobNo = jobNo;
      this.$refs["otherTallyExpCharges-modal"].show();
    },
    hideExpenseDet() {
      this.Mtitle = "";
      this.singleItem = "";
      this.ExpenseItemDeatils = [];
      this.taxAmount = 0;
      this.$refs["otherTallyExpCharges-modal"].hide();
    },
    getProfitLossData() {
      this.getInvoiceList = [];
      this.getExpenseList = [];
      let payload = {};
      if (this.PMS_fk_all_module_id != "") {
        payload = {
          itemCode: "ProfitLossSummary",
          Filter: {
            assignmentFilter: this.PMS_fk_all_module_id,
          },
        };

        ProfitLossService.getAllProfitLoss(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.getExpenseList.length > 0) {
                this.getExpenseList = data.getExpenseList;
              }
              if (data.getInvoiceList.length > 0) {
                this.getInvoiceList = data.getInvoiceList;
              }

              this.totInvVal = data.totInvVal.toFixed(2);
              this.totInvGST = data.totInvGST.toFixed(2);
              this.totInvGSTVal = data.totInvGSTVal.toFixed(2);

              this.totExpVal = data.totExpVal.toFixed(2);
              this.totExpGST = data.totExpGST.toFixed(2);
              this.totExpGSTVal = data.totExpGSTVal.toFixed(2);

              this.totPLVal = data.totPLVal.toFixed(2);
              this.totPLGST = data.totPLGST.toFixed(2);
              this.totPLGSTVal = data.totPLGSTVal.toFixed(2);
              this.totPLPercentage = ((this.totPLVal * 100) / this.totExpVal).toFixed(2);
              if (this.totPLVal > 0) {
                this.totPLValColor = "background:#28a745;color:white;font-weight:bold";
              } else if (this.totPLVal < 0) {
                this.totPLValColor = "background:#dc3545;color:white;font-weight:bold";
              } else {
                this.totPLValColor = "";
              }
            }
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// profitLoss.vue?7f83c306